export const NAME = 'appointmentList';